<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("cookie.menu.layout") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <div class="space-y-2">
                    <FormLabel>{{ $t("faq.layout.view_type") }}</FormLabel>
                    <FormSwitch
                        :options="layouts"
                        :modelValue="cookieType"
                        @update:modelValue="cookie.type = $event"
                    />
                </div>
                <template v-if="cookie.type == 'popup'">
                    <FormSelect
                        :value="cookie.corner"
                        :label="$t('cookie.layout.corner')"
                        :options="corners"
                        v-model="cookie.corner"
                    />
                </template>
                <template v-if="cookie.type === 'banner' || cookie.type === 'float'">
                    <div class="space-y-2">
                        <FormLabel>{{ $t("cookie.layout.corner") }}</FormLabel>
                        <FormSwitch :options="positions" v-model="cookie.position" />
                    </div>
                    <div class="space-y-2">
                        <FormLabel>{{ $t("cookie.layout.width") }}</FormLabel>
                        <FormSwitch :options="widths" v-model="cookie.type" />
                    </div>
                </template>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormSelect, FormSwitch, FormLabel } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    name: "SidebarLayout",
    components: {
        PageSidebar,
        FormSelect,
        FormSwitch,
        FormLabel,
        cSaveButton,
    },
    computed: {
        ...mapState("cookie", ["cookie", "hasChanges"]),
        cookieType() {
            if (this.cookie.type === "float") {
                return "banner";
            }
            return this.cookie.type;
        },
        layouts() {
            return [
                { label: this.$t("cookie.layout.banner"), value: "banner" },
                { label: this.$t("cookie.layout.modal"), value: "modal" },
                { label: this.$t("cookie.layout.popup"), value: "popup" },
            ];
        },
        corners() {
            return [
                { label: this.$t("cookie.layout.topleft"), value: "topleft" },
                { label: this.$t("cookie.layout.topright"), value: "topright" },
                { label: this.$t("cookie.layout.bottomleft"), value: "bottomleft" },
                { label: this.$t("cookie.layout.bottomright"), value: "bottomright" },
            ];
        },
        positions() {
            return [
                { label: this.$t("cookie.layout.top"), value: "top" },
                { label: this.$t("cookie.layout.bottom"), value: "bottom" },
            ];
        },
        widths() {
            return [
                { label: this.$t("cookie.layout.full"), value: "banner" },
                { label: this.$t("cookie.layout.floating"), value: "float" },
            ];
        },
    },
    methods: {
        ...mapActions("cookie", ["saveSnapshot"]),
    },
};
</script>
